import '@plone/components/dist/basic.css';

const InjectPloneComponentsCSS = () => {
  return null;
};

export default InjectPloneComponentsCSS;
